
  Vue.component('abb-menu-pager', {
    props: {
      currentPage: { type: Number, default: 1 },
      pages: { type: Array, required: true },
      showPageInfo: { type: Boolean, default: true },
      showIcon: { type: Boolean, default: true }
    },
    data() {
      return {}
    },
    template: '#abb-menu-pager',
    computed: {},
    watch: {},
    methods: {},
    mounted() {}
  })
